import { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

interface StoryModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const StoryModal: React.FC<StoryModalProps> = ({ isOpen, onClose }) => {
  const [story, setStory] = useState("");
  const [xLink, setXLink] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [wantsFollowUp, setWantsFollowUp] = useState(false);
const [contactInfo, setContactInfo] = useState('');


    const [storyText, setStoryText] = useState('');
    const [twitterLink, setTwitterLink] = useState('');


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
        await addDoc(collection(db, "stories"), {
          text: storyText,
          xLink: twitterLink,
          status: "pending",
          createdAt: serverTimestamp(),
          wantsFollowUp: wantsFollowUp,
          contactInfo: wantsFollowUp ? contactInfo : "",
        });
    
    // Clear any previous errors
    setError(null);
    
    if (!story.trim()) {
      setError('Please enter your story');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      await addDoc(collection(db, 'stories'), {
        text: story,
        xLink: xLink || '',
        status: 'pending',
        createdAt: new Date(),
      });
      
      setStory('');
      setXLink('');
      alert('Thank you for sharing your story! It will be reviewed shortly.');
      onClose();
    } catch (error) {
      console.error('Error submitting story:', error);
      
      if (error && typeof error === 'object' && 'code' in error) {
        const firebaseError = error as { code: string };
        
        if (firebaseError.code === 'permission-denied') {
          setError('You don\'t have permission to submit. Please try again later.');
        } else if (firebaseError.code === 'unavailable') {
          setError('Service temporarily unavailable. Please try again later.');
        } else {
          setError('An error occurred. Please try again.');
        }
      } else {
        setError('An unexpected error occurred. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  } catch (error) {
    console.error('Error submitting story:', error);
    setError('There was an error submitting your story. Please try again.');
    } finally {
        setIsSubmitting(false);
        }
    }
    

  // Use a single return statement with conditional rendering
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={onClose}>×</button>
            
            <h2>Share Your Story</h2>
            <p className="subtitle">Your experience could help someone else.</p>
            
            <form onSubmit={handleSubmit}>
              {error && (
                <div className="error-message">
                  {error}
                </div>
              )}
              
              <div className="form-group">
                <label htmlFor="story-text">Your Experience</label>
                <textarea
                  id="story-text"
                  value={story}
                  onChange={(e) => setStory(e.target.value)}
                  placeholder="Tell us how you beat cancer your way..."
                  rows={5}
                  required
                  className="story-textarea"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="x-link">Link to Your Post on X (optional)</label>
                <input
                  id="x-link"
                  type="text"
                  value={xLink}
                  onChange={(e) => setXLink(e.target.value)}
                  placeholder="https://x.com/yourusername/status/123456789"
                  className="x-link-input"
                />
              </div>
              <div className="form-group checkbox-group">
  <label>
    <input 
      type="checkbox" 
      checked={wantsFollowUp}
      onChange={(e) => setWantsFollowUp(e.target.checked)}
    />
    Would you like a follow-up about your story?
  </label>
</div>

{wantsFollowUp && (
  <div className="form-group">
    <label htmlFor="contactInfo">Contact information:</label>
    <input
      type="text"
      id="contactInfo"
      placeholder="Email or phone number"
      value={contactInfo}
      onChange={(e) => setContactInfo(e.target.value)}
      required={wantsFollowUp}
    />
    <small>This information will only be visible to administrators.</small>
  </div>
)}

              <button 
                type="submit" 
                className="btn btn-primary submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Story'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default StoryModal;